import React, { useContext, useEffect, useState } from 'react';

import { HttpMethods, FetchContext, ApiRoutes } from '../../../contexts';
import { useAggregatedState } from '../../../../helpers';

export const AssignmentListContext = React.createContext(null);

const { Provider } = AssignmentListContext;
export const AssignmentListProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [ state, setState ] = useAggregatedState({
        isLoadingTeams: false,
        projectTeams: null,
        isDeleted: false
    });

    const getProjectTeams = async (data) => {
        try {      
            setState({ isLoadingTeams: true });      
            const projectTeamsApi = await fetchAuthorized(ApiRoutes.User.GetProjectTeams({ pageSize: 1000 }),
            {                    
                method: HttpMethods.GET
            }); 
    
            const projectTeams = await projectTeamsApi.json();
            setState({ projectTeams, isDeleted: false, isLoadingTeams: false });
          }
    
          catch (ex){
            setState({ isLoadingTeams: false }); 
            console.error(ex);
            console.error(ex.details);
          }
    }

    const deleteTeamAsync = async (data) => {
        try {            
            await fetchAuthorized(ApiRoutes.User.DeleteProjectTeam({ projectTeamId: data }),
            {                    
                method: HttpMethods.DELETE
            });

            setState({ isDeleted: true });
          }
    
          catch (ex){
            console.error(ex);
            console.error(ex.details);
          }
    }

    return (
        <Provider value={{
            state,
            getProjectTeams,
            deleteTeamAsync
        }}>
            {props.children}
        </Provider>
    );
}